import React from "react"
import { Link } from "gatsby"

import Heading from "components/elements/heading"
import Title from "components/elements/title"
import Hr from "components/elements/hr"
import StaticImage from "components/media/static-image"
import HostedVideo from "components/media/hosted-video"
import Button from "components/form/button"

import cx from "classnames"
import * as s from "./previous-projects.module.sass"

const projectsData = require("data/previous-projects.json")

const ProjectCard = ({ project }) => (
  <div className={s.project}>
    <div className={s.media}>
      {project.videoSrc ? (
        <HostedVideo
          src={`${process.env.SITE_URL}${project.videoSrc}`}
          poster={project.image && `${process.env.SITE_URL}${project.image}`}
        />
      ) : (
        <StaticImage
          parentClass={s.image}
          src={`${process.env.SITE_URL}${project.image}`}
          alt={project.imageAlt || project.name}
        />
      )}
    </div>

    <div className={s.info}>
      <p className={s.name}>
        {project.path ? (
          <Link className={s.projectLink} to={project.path}>
            {project.name}
          </Link>
        ) : (
          <span>{project.name}</span>
        )}
        {project.wip && <span className={s.tag}>Work in progress</span>}
        {project.discontinued && <span className={s.tag}>Discontinued</span>}
      </p>

      <p className={s.meta}>
        <span className={s.metaLabel}>Engine:</span>{" "}
        <span className={s.metaValue}>{project.engine}</span>
        {project.multiplayer && (
          <span className={s.multiplayer}> · Multiplayer</span>
        )}
      </p>

      {project.platforms && (
        <p className={s.meta}>
          <span className={s.metaLabel}>Platforms:</span>{" "}
          <span className={s.metaValue}>{project.platforms.join(", ")}</span>
        </p>
      )}

      <p className={s.description}>{project.description}</p>
      {project.website && (
        <div className={s.website}>
          <Button href={project.website} color="yellow">
            Visit {project.name} website
          </Button>
        </div>
      )}
      {project.path && (
        <p className={s.more}>
          <Link className={s.projectLink} to={project.path}>
            How we’re making {project.name} at Netspeak Games
          </Link>
        </p>
      )}
    </div>
  </div>
)

const PreviousProjects = () => {
  const [current, ...previous] = projectsData

  return (
    <div id="games" className={s.component}>
      <Heading
        parentClass={s.heading}
        surtitle="What we're making"
        title="Our Projects"
        version="light"
      />

      <div className={cx("container", s.container)}>
        <div className={s.projects}>
          <ProjectCard project={current} />
        </div>

        <div className={s.split}>
          <Hr parentClass={s.splitHr} />
          <Title light parentClass={s.splitTitle}>
            Previously...
          </Title>
        </div>

        <div className={s.projects}>
          {previous.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default PreviousProjects
